import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';

import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { faMoneyCheck, faPeopleGroup, faCity, faTableColumns, faLocationDot, faUsers, faClipboardCheck, faStar, faUser, faClipboard, faListCheck } from '@fortawesome/free-solid-svg-icons';
import { SideBarNavigationModel } from 'src/app/models/sideBarNavigation.model';
import { ContentService } from 'src/app/shared/content.service';

@Component({
  standalone: true,
    imports: [RouterModule, FontAwesomeModule, NgbCollapseModule],
  selector: 'app-left-nav',
  templateUrl: './left-nav.component.html',
  styleUrls: ['./left-nav.component.css']
})
export class LeftNavComponent {

  @Input() model: SideBarNavigationModel;
  faTableColumns = faTableColumns;
  faCity = faCity;
  faMapLocationDot = faLocationDot;
  faUsers = faUsers;
  faClipboardCheck = faClipboardCheck;
  faStar = faStar;
  faUser = faUser;
  faClipboard = faClipboard;
  faListCheck = faListCheck;
  faPeopleGroup = faPeopleGroup;
  faMoneyCheck = faMoneyCheck;




  isCollapsedPp = false;
  isCollapsedSp = false;
  errorMessage = '';

  constructor(private contentService: ContentService) { }
  ngOnInit(): void {
    if (!this.model) {
      this.getSideBarData();
    }
  }
  getSideBarData() {
    this.contentService.getSideBarNavigation().subscribe(
      (data: SideBarNavigationModel) => this.model = data,
      (error: HttpErrorResponse) => this.onError(error)
    );
  }

  onError(error: HttpErrorResponse) {
    // this.hideErrorMessage = false;
    // this.isLoading = false;
    if (error.status === 400) {
      this.errorMessage = error?.error[0]?.description;
    } else if (error.status === 500 || error.status === 0) {
      this.errorMessage = 'We found an error in our systems, our engineers on it so no worries. Please check back in a few minutes.';
    }
    console.log(error);
  }
}
